import { Archive, Ellipsis, UserRoundCog, UserRoundPen } from "lucide-react"
import { useState } from "react"

import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@atlant/ui"

import type { AircraftSource } from "#gql/graphql.ts"
import { AssignKamModal } from "#pages/authenticated/fleet/[aircraftId]/components/assign-kam-modal.tsx"
import { AssignOwnerModal } from "#pages/authenticated/fleet/[aircraftId]/components/assign-owner-modal.tsx"

interface FleetRowActionsProps {
  source: AircraftSource
  aircraftId: string
  currentKamIds?: string[]
  currentOwnerId?: string
}

export const FleetRowActions = ({
  source,
  aircraftId,
  currentKamIds,
  currentOwnerId,
}: FleetRowActionsProps) => {
  const [kamModalOpen, setKamModalOpen] = useState(false)
  const [ownerModalOpen, setOwnerModalOpen] = useState(false)

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            variant="ghost"
            size="icon"
            className="size-8"
            onClick={(e) => e.stopPropagation()}
          >
            <Ellipsis className="text-muted-foreground size-4" />
          </Button>
        </DropdownMenuTrigger>

        <DropdownMenuContent align="end">
          <DropdownMenuItem onSelect={() => setKamModalOpen(true)} className="gap-2">
            <UserRoundCog className="size-4" />
            Change KAMs
          </DropdownMenuItem>
          <DropdownMenuItem onSelect={() => setOwnerModalOpen(true)} className="gap-2">
            <UserRoundPen className="size-4" />
            Change owner
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem disabled className="gap-2">
            <Archive className="size-4" />
            Archive aircraft
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      <AssignKamModal
        source={source}
        aircraftId={aircraftId}
        open={kamModalOpen}
        onOpenChange={setKamModalOpen}
        defaultUserIds={currentKamIds}
      />
      <AssignOwnerModal
        source={source}
        aircraftId={aircraftId}
        open={ownerModalOpen}
        onOpenChange={setOwnerModalOpen}
        defaultOwnerId={currentOwnerId}
      />
    </>
  )
}
